/* eslint-disable no-unused-vars */
import React, { useState, useRef, useEffect } from "react";
import {
  Grid,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Stack,
  TableBody,
  Divider,
  Box,
} from "@mui/material";
import FormTitle from "../../../form-fields/form-title";
import SelectInput from "../../../form-fields/select-input";
import DashBoardContainer from "../../../layout/dashboard-container";
import {
  FormLabel,
  FormValue,
  GridRow,
} from "../generate-receipt/custom-form-grid";
import { useSelector } from "react-redux";
import { labels } from "../../../../lang/labels";
import { useFormik, FormikProvider, Form } from "formik";
import { ArrowBack, Print } from "@mui/icons-material";
import FormButtons from "../buttons";
import DateInput from "../../../form-fields/date-picker";
import { useReactToPrint } from "react-to-print";
import { getZoneWiseReportSchema } from "../../../../utils/validation-schema";
import { getUserZoneList } from "../../../../services/coinage-challan-service";
import { getModeOfPayments } from "../../../../services/generate-counter-receipt";
import useApi from "../../../common/useApiHook";
import { getZoneWiseReceiptReport } from "../../../../services/stamp-service";
import Loader from "../../../loader/loader";
import AlertMsg from "../../../common/alert";
import { getCurrentDate, getErrorMsg } from "../../../../utils/helpers";
import ScrollTop from "../../../common/scrollTop";
import { showToastError } from "../../../common/toastHelper";
import ScrollBottom from "../../../common/scrollBottom";

const ZonewiseReceiptReport = () => {
  const printRef = useRef();

  const initialState = {
    zoneName: "",
    modeofPayment: "",
    counter: "",
    fromDate: getCurrentDate(),
    toDate: getCurrentDate(),
  };

  const lang = useSelector((state) => state.userDetails.lang);
  const formik = useFormik({
    initialValues: initialState,
    validationSchema: getZoneWiseReportSchema,
  });

  const [zoneWiseReportData, setZoneWiseReportData] = useState("");

  const { loading, error, callApi, setError } = useApi(
    getZoneWiseReceiptReport
  );
  // eslint-disable-next-line no-unused-vars
  const [counterList, setCounterList] = useState([
    { value: "COUNTER1", label: "1" },
    { value: "COUNTER2", label: "2" },
  ]);
  const [zones, setZoneList] = useState([]);
  const [modeOfPayments, setModeOfPayments] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [modeOfPaymentsData, zoneListRes] = await Promise.all([
          getModeOfPayments(),
          getUserZoneList(),
        ]);

        const zoneList = zoneListRes.map((record) => ({
          value: record.zonename,
          label: record.zonename,
        }));
        setZoneList(zoneList);
        const modeOfPaymentList = modeOfPaymentsData.map((record) => ({
          value: record.name,
          label: record.name,
        }));
        setModeOfPayments(modeOfPaymentList);
      } catch (error) {
        showToastError(getErrorMsg(error));
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty dependency array ensures it runs only once

  const handleSubmitButtonClick = async (e) => {
    e.preventDefault();
    const response = await callApi(formik.values);
    setZoneWiseReportData(response);
  };

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  return (
    <DashBoardContainer>
      <ScrollBottom />
      {loading && <Loader />}
      {error && (
        <AlertMsg
          severity="error"
          onClose={() => {
            setError("");
          }}
        />
      )}
      <FormikProvider value={formik}>
        <Form>
          <Paper elevation={4} sx={{ marginBottom: "15px" }}>
            <FormTitle title={labels.zonewiseReceiptReport[lang]} />
            <Grid>
              <GridRow>
                <FormLabel label={labels.FromDate[lang]} required />
                <FormValue component={<DateInput name="fromDate" required />} />
                <FormLabel label={labels.ToDate[lang]} required />
                <FormValue component={<DateInput name="toDate" required />} />
              </GridRow>
              <GridRow>
                <FormLabel label={labels.Zone[lang]} required />
                <FormValue
                  component={
                    <SelectInput name="zoneName" options={zones} required />
                  }
                />
                <FormLabel label={labels.Counter[lang]} required />
                <FormValue
                  component={
                    <SelectInput
                      name="counter"
                      options={counterList}
                      required
                    />
                  }
                />
              </GridRow>
              <GridRow>
                <FormLabel label={labels.ModeOfPayment[lang]} required />
                <FormValue
                  component={
                    <SelectInput
                      name="modeofPayment"
                      options={modeOfPayments}
                      required
                    />
                  }
                />
              </GridRow>
              <Grid container justifyContent="center" alignItems="center">
                <Grid
                  item
                  md={3}
                  container
                  justifyContent={{ md: "flex-end" }}
                  alignItems="center"
                  p={2}
                >
                  <FormButtons
                    isValid={!(formik.isValid && formik.dirty)}
                    handleSubmitButtonClick={handleSubmitButtonClick}
                    resetForm={() => {
                      formik.resetForm();
                      setError("");
                      setZoneWiseReportData("");
                    }}
                    submitBtnLabel="Show"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </Form>
        {zoneWiseReportData ? (
          <>
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                sx={{ margin: 2 }}
                onClick={handlePrint}
                variant="contained"
                startIcon={<Print />}
              >
                Print
              </Button>
              {/* <Button
                sx={{ margin: 2 }}
                onClick={() => {
                  navigate(-1);
                }}
                variant="contained"
                startIcon={<ArrowBack />}
              >
                Back
              </Button> */}
            </Box>

            <Grid ref={printRef}>
              <Grid container justifyContent="center">
                <Grid
                  sx={{
                    textAlign: "center", // Centers the text horizontally
                    fontWeight: "bold", // Ensures the text is bold
                  }}
                >
                  <b>
                    पिंपरी चिंचवड महानगरपालिका,पिंपरी - ४११०१८
                    <br />
                    कर संकलन विभाग
                    <br />
                    {labels.ZonewiseReceiptList[lang]}
                  </b>
                </Grid>
              </Grid>
              
              <Grid
                container
                spacing={2}
                sx={{ width: "85%", marginLeft: "110px" }}
              >
                <Grid item xs={12} sm={6} md={6}>
                  <div>
                    {labels.Zone[lang]} - {formik.values.zoneName}
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <div>
                    {labels.Counter[lang]} - {formik.values.counter}
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <div>
                    पासून - {formik.values.fromDate} ते {formik.values.toDate}
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <div>
                    {labels.ModeOfPayment[lang]} - {formik.values.modeofPayment}
                  </div>
                </Grid>
              </Grid>
              <br />
              <Divider />
              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <h5 style={{ margin: "5px" }}>
                  {labels.BillReceiptDetails[lang]}
                </h5>
              </Grid>
              <GridRow>
                <TableContainer style={{ padding: "20px" }}>
                  <Table
                    size="small"
                    sx={{ minWidth: 600 }}
                    aria-label="simple table"
                  >
                    <TableHead>
                      <TableRow
                        sx={{
                          background: "#e6eaeb",
                          "&:last-child td, &:last-child th": {
                            border: "1px solid black",
                          },
                        }}
                      >
                        <TableCell align="center">
                          {labels.SrNo[lang]}
                        </TableCell>
                        <TableCell align="center">
                          {labels.PropertyCode[lang]}
                        </TableCell>
                        <TableCell align="center">
                          {labels.PropertyName[lang]}
                        </TableCell>
                        <TableCell align="center">
                          {labels.ReceiptDate[lang]}
                        </TableCell>
                        <TableCell align="center">
                          {labels.ReceiptNumber[lang]}
                        </TableCell>
                        <TableCell align="center">
                          {labels.ModeOfPayment[lang]}
                        </TableCell>
                        <TableCell align="center">
                          {labels.Amount[lang]}
                        </TableCell>
                        <TableCell align="center">
                          {labels.ReceiptStatus[lang]}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {zoneWiseReportData &&
                      zoneWiseReportData.lstBillreceiptData &&
                      zoneWiseReportData.lstBillreceiptData.length ? (
                        <>
                          {zoneWiseReportData.lstBillreceiptData.map(
                            (item, index) => (
                              <TableRow>
                                <TableCell
                                  align="center"
                                  className="cellBorder"
                                  sx={{
                                    color:
                                      item.receiptStatus === "Canceled Receipt"
                                        ? "red"
                                        : "inherit",
                                  }}
                                >
                                  {index + 1}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="cellBorder"
                                  sx={{
                                    color:
                                      item.receiptStatus === "Canceled Receipt"
                                        ? "red"
                                        : "inherit",
                                  }}
                                >
                                  {item.propertycode}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="cellBorder"
                                  sx={{
                                    color:
                                      item.receiptStatus === "Canceled Receipt"
                                        ? "red"
                                        : "inherit",
                                  }}
                                >
                                  {item.propertyname}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="cellBorder"
                                  sx={{
                                    color:
                                      item.receiptStatus === "Canceled Receipt"
                                        ? "red"
                                        : "inherit",
                                  }}
                                >
                                  {item.receiptDate}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="cellBorder"
                                  sx={{
                                    color:
                                      item.receiptStatus === "Canceled Receipt"
                                        ? "red"
                                        : "inherit",
                                  }}
                                >
                                  {item.receiptno}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="cellBorder"
                                  sx={{
                                    color:
                                      item.receiptStatus === "Canceled Receipt"
                                        ? "red"
                                        : "inherit",
                                  }}
                                >
                                  {item.modeofpayment}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="cellBorder"
                                  sx={{
                                    color:
                                      item.receiptStatus === "Canceled Receipt"
                                        ? "red"
                                        : "inherit",
                                  }}
                                >
                                  {item.paidamount}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="cellBorder"
                                  sx={{
                                    color:
                                      item.receiptStatus === "Canceled Receipt"
                                        ? "red"
                                        : "inherit",
                                  }}
                                >
                                  {item.receiptStatus}
                                </TableCell>
                              </TableRow>
                            )
                          )}
                          <TableRow>
                            <TableCell
                              align="right"
                              className="cellBorder"
                              colSpan="6"
                              style={{ fontWeight: "bold" }}
                            >
                              {labels.BillReceiptTotal[lang]}
                            </TableCell>
                            <TableCell
                              align="center"
                              className="cellBorder"
                              style={{ fontWeight: "bold" }}
                            >
                              {zoneWiseReportData.receiptTotal}
                            </TableCell>
                            <TableCell
                              align="center"
                              className="cellBorder"
                            ></TableCell>
                          </TableRow>
                        </>
                      ) : (
                        <TableRow>
                          <TableCell
                            align="center"
                            className="cellBorder"
                            colSpan={8}
                          >
                            {labels.NoRecordFound[lang]}
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </GridRow>
              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <h5 style={{ margin: "5px" }}>
                  {labels.GeneralReceiptDetails[lang]}
                </h5>
              </Grid>
              <GridRow>
                <TableContainer style={{ padding: "20px" }}>
                  <Table
                    size="small"
                    sx={{ minWidth: 600 }}
                    aria-label="simple table"
                  >
                    <TableHead>
                      <TableRow
                        sx={{
                          background: "#e6eaeb",
                          "&:last-child td, &:last-child th": {
                            border: "1px solid black",
                          },
                        }}
                      >
                        <TableCell align="center">
                          {labels.SrNo[lang]}
                        </TableCell>
                        <TableCell align="center">
                          {labels.PropertyCode[lang]}
                        </TableCell>
                        <TableCell align="center">
                          {labels.PropertyName[lang]}
                        </TableCell>
                        <TableCell align="center">
                          {labels.ReceiptDate[lang]}
                        </TableCell>
                        <TableCell align="center">
                          {labels.ReceiptNumber[lang]}
                        </TableCell>
                        <TableCell align="center">
                          {labels.ModeOfPayment[lang]}
                        </TableCell>
                        <TableCell align="center">
                          {labels.Amount[lang]}
                        </TableCell>
                        <TableCell align="center">
                          {labels.ReceiptStatus[lang]}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {zoneWiseReportData &&
                      zoneWiseReportData.lstPrefilledreceiptData &&
                      zoneWiseReportData.lstPrefilledreceiptData.length ? (
                        <>
                          {zoneWiseReportData.lstPrefilledreceiptData.map(
                            (item, index) => (
                              <TableRow>
                                <TableCell
                                  align="center"
                                  className="cellBorder"
                                  sx={{
                                    color:
                                      item.receiptStatus === "Canceled Receipt"
                                        ? "red"
                                        : "inherit",
                                  }}
                                >
                                  {index + 1}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="cellBorder"
                                  sx={{
                                    color:
                                      item.receiptStatus === "Canceled Receipt"
                                        ? "red"
                                        : "inherit",
                                  }}
                                >
                                  {item.propertycode}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="cellBorder"
                                  sx={{
                                    color:
                                      item.receiptStatus === "Canceled Receipt"
                                        ? "red"
                                        : "inherit",
                                  }}
                                >
                                  {item.propertyname}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="cellBorder"
                                  sx={{
                                    color:
                                      item.receiptStatus === "Canceled Receipt"
                                        ? "red"
                                        : "inherit",
                                  }}
                                >
                                  {item.receiptDate}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="cellBorder"
                                  sx={{
                                    color:
                                      item.receiptStatus === "Canceled Receipt"
                                        ? "red"
                                        : "inherit",
                                  }}
                                >
                                  {item.receiptno}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="cellBorder"
                                  sx={{
                                    color:
                                      item.receiptStatus === "Canceled Receipt"
                                        ? "red"
                                        : "inherit",
                                  }}
                                >
                                  {item.modeofpayment}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="cellBorder"
                                  sx={{
                                    color:
                                      item.receiptStatus === "Canceled Receipt"
                                        ? "red"
                                        : "inherit",
                                  }}
                                >
                                  {item.paidamount}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="cellBorder"
                                  sx={{
                                    color:
                                      item.receiptStatus === "Canceled Receipt"
                                        ? "red"
                                        : "inherit",
                                  }}
                                >
                                  {item.receiptStatus}
                                </TableCell>
                              </TableRow>
                            )
                          )}
                          <TableRow>
                            <TableCell
                              align="right"
                              className="cellBorder"
                              colSpan="6"
                              style={{ fontWeight: "bold" }}
                            >
                              {labels.ZoneReceiptTotal[lang]}
                            </TableCell>
                            <TableCell
                              align="center"
                              className="cellBorder"
                              style={{ fontWeight: "bold" }}
                            >
                              {zoneWiseReportData.prefilledTotal}
                            </TableCell>
                            <TableCell
                              align="center"
                              className="cellBorder"
                            ></TableCell>
                          </TableRow>
                        </>
                      ) : (
                        <TableRow>
                          <TableCell
                            align="center"
                            className="cellBorder"
                            colSpan={8}
                          >
                            {labels.NoRecordFound[lang]}
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </GridRow>

              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                }}
              ></Grid>
              <GridRow>
                <TableContainer style={{ padding: "20px" }}>
                  <Table
                    size="small"
                    sx={{ minWidth: 600 }}
                    aria-label="simple table"
                  >
                    <TableBody>
                      <TableRow>
                        <TableCell
                          align="right"
                          className="cellBorder"
                          colSpan="6"
                          style={{ fontWeight: "bold", width: "70%" }}
                        >
                          {labels.Total[lang]}
                        </TableCell>
                        <TableCell
                          align="center"
                          className="cellBorder"
                          style={{ fontWeight: "bold" }}
                        >
                          {zoneWiseReportData.total}
                        </TableCell>
                        <TableCell
                          align="center"
                          className="cellBorder"
                        ></TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </GridRow>
            </Grid>
          </>
        ) : (
          <></>
        )}
      </FormikProvider>
      <ScrollTop />
    </DashBoardContainer>
  );
};
export default ZonewiseReceiptReport;
